import { createSlice } from "@reduxjs/toolkit";

export const productSlice = createSlice({
  name: "product",
  initialState: {
    all: [],
    byId: [],
    isLoading: true,
    stock: {
      all: [],
      byId: [],
      isLoading: true,
    },
    group: {
      all: [],
      byId: [],
      isLoading: true,
    },
  },
  reducers: {
    load: (state, action) => {
      state.all = action.payload.data;
      state.byId = action.payload.data.map((data) => data.id);
      state.isLoading = false;
    },
    update: (state, action) => {
      state.all = state.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    create: (state, action) => {
      state.all.push({ ...action.payload });
      state.byId.push(action.payload.id);
    },
    remove: (state, action) => {
      state.all = state.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.byId = [...state.byId].reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadStock: (state, action) => {
      state.stock.all = action.payload.data;
      state.stock.byId = action.payload.data.map((data) => data.id);
      state.stock.isLoading = false;
    },
    updateStock: (state, action) => {
      state.stock.all = state.stock.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    createStock: (state, action) => {
      state.stock.all.push({ ...action.payload });
      state.stock.byId.push(action.payload.id);
    },
    removeStock: (state, action) => {
      state.stock.all = state.stock.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.stock.byId = state.stock.byId.reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },

    loadGroup: (state, action) => {
      state.group.all = action.payload.data;
      state.group.byId = action.payload.data.map((data) => data.id);
      state.group.isLoading = false;
    },
    updateGroup: (state, action) => {
      state.group.all = state.group.all.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
    },
    createGroup: (state, action) => {
      state.group.all.push({ ...action.payload });
      state.group.byId.push(action.payload.id);
    },
    removeGroup: (state, action) => {
      state.group.all = state.group.all.reduce(
        (agg, item) =>
          parseInt(item.id) === action.payload ? agg : [...agg, item],
        []
      );

      state.group.byId = state.group.byId.reduce(
        (agg, item) =>
          parseInt(item) === action.payload ? agg : [...agg, item],
        []
      );
    },
  },
});

export const {
  load,
  create,
  update,
  remove,
  loadStock,
  createStock,
  updateStock,
  removeStock,
  loadGroup,
  createGroup,
  updateGroup,
  removeGroup,
} = productSlice.actions;

export default productSlice.reducer;
